export type InvoiceSendMode = 'final' | 'draft'

export function consumeInvoiceSendIntent(searchParams: URLSearchParams): {
  mode: InvoiceSendMode | undefined
  searchParams: URLSearchParams
} | null {
  if (searchParams.get('send') !== '1') return null

  const modeParam = searchParams.get('send_mode')
  const mode =
    modeParam === 'final' || modeParam === 'draft' ? modeParam : undefined
  const nextSearchParams = new URLSearchParams(searchParams)
  nextSearchParams.delete('send')
  nextSearchParams.delete('send_mode')

  return { mode, searchParams: nextSearchParams }
}
